import { Box } from '@mui/material';
import HeaderSearch from './Search';
import HeaderNotifications from './Notifications';

function HeaderButtons() {
  return (
    <Box sx={{ mr: 1 }}>
      {/* TODO: get search working*/}
      {/* <HeaderSearch /> */}
      <Box sx={{ mx: 0.5 }} component="span">
        {/* TODO: get notifications working */}
        {/* <HeaderNotifications /> */}
      </Box>
    </Box>
  );
}

export default HeaderButtons;
